"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonLinkFlex = exports.StyledLogo = exports.StyledButtonLink = exports.StyledButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const focusHover_1 = require("../../styles/focusHover");
const tokens_1 = require("../../styles/tokens");
const getButtonColourStyles = (theme, dimension) => {
    switch (theme) {
        case "success":
            return {
                backgroundColor: tokens_1.COLOURS.primary.green["100"],
                boxShadow: dimension === "large"
                    ? tokens_1.SHADOWS.raisedInset.high.green
                    : tokens_1.SHADOWS.raisedInset.medium.green,
                color: tokens_1.COLOURS.greyscale.white,
            };
        case "danger":
            return {
                backgroundColor: tokens_1.COLOURS.primary.red["100"],
                boxShadow: dimension === "large"
                    ? tokens_1.SHADOWS.raisedInset.high.red
                    : tokens_1.SHADOWS.raisedInset.medium.red,
                color: tokens_1.COLOURS.greyscale.white,
            };
        case "secondary":
            return {
                backgroundColor: tokens_1.COLOURS.greyscale.white,
                boxShadow: dimension === "large"
                    ? tokens_1.SHADOWS.raisedInset.high.silver
                    : tokens_1.SHADOWS.raisedInset.medium.silver,
                color: tokens_1.COLOURS.greyscale.zinc,
            };
        case "transparent":
            return {
                backgroundColor: tokens_1.COLOURS.transparent,
                color: tokens_1.COLOURS.greyscale.zinc,
                boxShadow: "none",
            };
        case "disabled":
            return {
                backgroundColor: tokens_1.COLOURS.greyscale.silver,
                color: tokens_1.COLOURS.greyscale.zinc,
                boxShadow: "none",
            };
        case "disabledTransparent":
            return {
                backgroundColor: tokens_1.COLOURS.transparent,
                color: tokens_1.COLOURS.greyscale.stone,
                boxShadow: "none",
            };
        case "primary":
        default:
            return {
                backgroundColor: tokens_1.COLOURS.primary.blue["100"],
                boxShadow: dimension === "large"
                    ? tokens_1.SHADOWS.raisedInset.high.blue
                    : tokens_1.SHADOWS.raisedInset.medium.blue,
                color: tokens_1.COLOURS.greyscale.white,
            };
    }
};
const getButtonHoverBackgroundColour = (color) => {
    switch (color) {
        case "success":
            return tokens_1.COLOURS.primary.green["130"];
        case "danger":
            return tokens_1.COLOURS.primary.red["130"];
        case "transparent":
        case "disabledTransparent":
            return tokens_1.COLOURS.primary.blue["10"];
        case "secondary":
        case "disabled":
            return tokens_1.COLOURS.greyscale.silver;
        case "primary":
        default:
            return tokens_1.COLOURS.primary.blue["130"];
    }
};
const getButtonBorder = (color) => {
    switch (color) {
        case "success":
            return tokens_1.BORDERS.normal.green;
        case "danger":
            return tokens_1.BORDERS.normal.red;
        case "transparent":
        case "disabledTransparent":
            return tokens_1.BORDERS.normal.transparent;
        case "secondary":
        case "disabled":
            return tokens_1.BORDERS.normal.silver;
        case "primary":
        default:
            return tokens_1.BORDERS.normal.blue;
    }
};
exports.StyledButton = styled_components_1.default.button `
    ${focusHover_1.defaultStyles}
    position: relative;
    display: ${({ as }) => as === "span" ? "inline-flex" : "flex"};
    align-items: center;
    padding: ${(props) => tokens_1.BUTTON_FORM_FIELDS_PADDING[props.innerStyle][props.dimension]};
    ${({ disabled, theme, dimension }) => {
    const buttonType = disabled
        ? theme === "transparent"
            ? "disabledTransparent"
            : "disabled"
        : theme;
    return getButtonColourStyles(buttonType, dimension);
}}

    border: ${({ disabled, theme }) => {
    const buttonType = disabled
        ? theme === "transparent"
            ? "disabledTransparent"
            : "disabled"
        : theme;
    return getButtonBorder(buttonType);
}};

    &:active,
    &:focus,
    &:hover {
        cursor: ${(props) => props.disabled ? "not-allowed" : "pointer"};
        background-color: ${({ disabled, theme }) => {
    const buttonType = disabled
        ? theme === "transparent"
            ? "disabledTransparent"
            : "disabled"
        : theme;
    return getButtonHoverBackgroundColour(buttonType);
}};
    }
    &:focus&:focus,
    &:focus-visible {
        ${focusHover_1.focusOnlyStyles}
    }

    // Add margin to text when an icon is present
    > :nth-child(2) {
        margin-left: ${tokens_1.SIZES[0.5]};
    }
`;
exports.StyledButtonLink = styled_components_1.default.a `
    ${focusHover_1.defaultStyles}
    text-decoration: none;
    &:active,
    &:focus,
    &:focus-visible,
    &:hover {
        ${focusHover_1.focusHoverSharedStyles}
    }
    &:focus&:focus {
        ${focusHover_1.focusOnlyStyles}
    }
`;
exports.StyledLogo = styled_components_1.default.span `
    height: 24px;
`;
exports.StyledButtonLinkFlex = styled_components_1.default.span `
    display: flex;
`;
//# sourceMappingURL=Button.styles.js.map